import { classifyUnknownError } from "../domain/errors";

export const TracePhase = {
  START: "START",
  END: "END",
} as const;

export const TraceOutcome = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  PENDING: "PENDING",
} as const;

interface TraceRecord {
  readonly traceId: string;
  readonly operation: string;
  readonly phase: (typeof TracePhase)[keyof typeof TracePhase];
  readonly durationMs: number;
  readonly outcome: (typeof TraceOutcome)[keyof typeof TraceOutcome];
  readonly errorType: string | null;
}

export function createTraceId(): string {
  return crypto.randomUUID();
}

export async function traceAsync<T>(
  traceId: string,
  operation: string,
  work: () => Promise<T>,
): Promise<T> {
  const startedAt = performance.now();
  emitTrace({
    traceId,
    operation,
    phase: TracePhase.START,
    durationMs: 0,
    outcome: TraceOutcome.PENDING,
    errorType: null,
  });

  try {
    const result = await work();
    emitTrace({
      traceId,
      operation,
      phase: TracePhase.END,
      durationMs: Math.round(performance.now() - startedAt),
      outcome: TraceOutcome.SUCCESS,
      errorType: null,
    });
    return result;
  } catch (error: unknown) {
    const classifiedError = classifyUnknownError(error);
    emitTrace({
      traceId,
      operation,
      phase: TracePhase.END,
      durationMs: Math.round(performance.now() - startedAt),
      outcome: TraceOutcome.FAILURE,
      errorType: classifiedError.classification,
    });
    throw classifiedError;
  }
}

export function traceSync<T>(
  traceId: string,
  operation: string,
  work: () => T,
): T {
  const startedAt = performance.now();
  emitTrace({
    traceId,
    operation,
    phase: TracePhase.START,
    durationMs: 0,
    outcome: TraceOutcome.PENDING,
    errorType: null,
  });

  try {
    const result = work();
    emitTrace({
      traceId,
      operation,
      phase: TracePhase.END,
      durationMs: Math.round(performance.now() - startedAt),
      outcome: TraceOutcome.SUCCESS,
      errorType: null,
    });
    return result;
  } catch (error: unknown) {
    const classifiedError = classifyUnknownError(error);
    emitTrace({
      traceId,
      operation,
      phase: TracePhase.END,
      durationMs: Math.round(performance.now() - startedAt),
      outcome: TraceOutcome.FAILURE,
      errorType: classifiedError.classification,
    });
    throw classifiedError;
  }
}

function emitTrace(record: TraceRecord): void {
  console.info(JSON.stringify(record));
}
